/**
 * cm-mega-menu -- header mega menu ozel ogesi.
 *
 * Neden tema JS'i degil: Prestige mega menuyu <details>/<summary> + `mega-menu-disclosure`
 * ile aciyor. <details> kapaliyken icerigi HIC cizmedigi icin acilis/kapanis gecisi
 * (referansta 0.36s clip-path + 0.27s opacity) CSS ile yapilamiyor. Bu oge paneli
 * her zaman DOM'da tutar, yalnizca `is-open` sinifini degistirir; gorsel gecisler
 * tamamen custom-overrides.css bolum 26'da.
 *
 * Markup (sections/header.liquid):
 *   <cm-mega-menu trigger="hover|click">
 *     <a href=...>SHOP</a>            <- tetikleyici / baglanti
 *     <div class="cm-mega-menu__panel">...</div>
 *   </cm-mega-menu>
 *
 * Davranis:
 *   hover  : fare ogeye girince acilir, cikinca kapanir. 30ms tolerans yalnizca link
 *            kutusu ile CSS'teki kopru seridi (bolum 26.2) arasindaki 2px'lik bosluk
 *            icin; referans olcumunde kapanis 0ms'de basliyor, 30ms algilanmaz. Dokunmatik /
 *            imlecsiz cihazlarda otomatik olarak tiklama moduna duser.
 *   click  : ilk tiklama acar (baglantiya gitmez), acikken tiklama baglantiya gider,
 *            disari tiklama kapatir.
 *   klavye : odak icerideyken acik, odak cikinca kapanir, Escape kapatip odagi linke verir.
 *   Ayni anda tek panel: biri acilinca digerleri kapanir.
 *
 * Bu dosya theme.js bundle'indan bagimsizdir (layout/theme.liquid'de ayri <script>).
 */
(() => {
  if (customElements.get('cm-mega-menu')) return;

  class CmMegaMenu extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector(':scope > a');
      this.panel = this.querySelector(':scope > .cm-mega-menu__panel');
      if (!this.link || !this.panel || this._wired) return;
      this._wired = true;
      this.isOpen = false;
      this._closeTimer = null;

      const wantsHover = (this.getAttribute('trigger') || 'hover') === 'hover';
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      if (wantsHover && canHover) {
        this.addEventListener('mouseenter', () => this.open());
        this.addEventListener('mouseleave', () => this.close(30));
      } else {
        this.link.addEventListener('click', (event) => {
          if (!this.isOpen) { event.preventDefault(); this.open(); }
        });
        document.addEventListener('click', (event) => {
          if (this.isOpen && !this.contains(event.target)) this.close();
        });
      }

      this.addEventListener('focusin', () => this.open());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.close();
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.isOpen) { this.close(); this.link.focus(); }
      });
      document.addEventListener('cm-mega-menu:open', (event) => {
        if (event.detail !== this) this.close();
      });
    }

    open() {
      clearTimeout(this._closeTimer);
      if (this.isOpen) return;
      this.isOpen = true;
      this.classList.add('is-open');
      this.link.setAttribute('aria-expanded', 'true');
      document.dispatchEvent(new CustomEvent('cm-mega-menu:open', { detail: this }));
    }

    close(delay = 0) {
      clearTimeout(this._closeTimer);
      if (!this.isOpen) return;
      const run = () => {
        this.isOpen = false;
        this.classList.remove('is-open');
        this.link.setAttribute('aria-expanded', 'false');
      };
      if (delay > 0) this._closeTimer = setTimeout(run, delay); else run();
    }
  }

  customElements.define('cm-mega-menu', CmMegaMenu);
})();
